import { FETCH_QUOTES, RESET } from '../constants/action-types';

const initialState = {
  items: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_QUOTES:
      return { ...state, items: action.payload.results };
    case RESET:
      return initialState;
    default:
      return state;
  }
}
